import type { IconProps } from './IconProps';

export function UserExcludeIcon({ className }: IconProps) {
  return <svg className={className} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <circle cx="9" cy="7" r="4" /><path d="M2 21v-2a7 7 0 0 1 11-5.7M16 14l6 6m0-6-6 6" />
  </svg>;
}
